import { render, staticRenderFns } from "./FmBreadcrumb.vue?vue&type=template&id=0384541a&scoped=true&"
import script from "./FmBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./FmBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./FmBreadcrumb.vue?vue&type=style&index=0&id=0384541a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384541a",
  null
  
)

export default component.exports